<template>
  <v-list three-line>
    <v-list-item v-if="items.length === 0">
      <v-list-item-title class="text-center">
        Nenhum endereço encontrado
      </v-list-item-title>
    </v-list-item>
    <div v-else v-for="item in items" :key="item.id">
      <ClientAddressItem
        @click="$emit('click', item)"
        @click:delete="$emit('click:delete', item)"
        :item="item"
      />
      <v-divider></v-divider>
    </div>
  </v-list>
</template>

<script>
import ClientAddressItem from "@/components/ClientAddressItem";

export default {
  props: {
    items: Array,
    loading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ClientAddressItem
  }
};
</script>
